export default async (): Promise<boolean> => {
  const response = await fetch('/logout', {
    method: 'POST',
  });

  return response.ok;
};
